<template>
  <div class="space-y-4">
    <div class="flex justify-between items-center px-1">
      <label class="text-[16px] font-bold text-foreground">Bio</label>
      <span class="text-sm text-muted-foreground font-medium">
        {{ value ? value.length : 0 }}/1000
      </span>
    </div>
    <div class="relative group">
      <textarea
        :value="value"
        @input="$emit('update:value', $event.target.value)"
        maxlength="1000"
        placeholder="I am a..."
        class="block w-full h-[280px] px-6 py-6 rounded-2xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 focus:border-primary/30 transition-all resize-none leading-relaxed text-[16px]"
      ></textarea>

      <!-- Resize indicator icon (decorative) -->
      <svg
        class="absolute bottom-4 right-4 w-4 h-4 text-muted-foreground/30"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 15L15 21M21 8L8 21"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "BioForm",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value"],
};
</script>
